import { FormCategory } from './enums/form-category.enum';
import { UserRoleScope } from '../user-api/enums/user-role-scope.enum';

/** Base path of the forms area in the frontend (without leading slash). The category is appended as URL segment. */
export const FORMS_BASE_PATH = 'forms/instances';

/**
 * All form categories in display order. Each category belongs to exactly ONE scope which grants access to it;
 * one scope may cover several categories.
 *
 * How to add a new form category:
 * 1. Add the category to `FormCategory` (`enums/form-category.enum.ts`); the value is the `category` of the
 *    form definition/instances and the URL segment (`/forms/instances/<category>`).
 * 2. Add an entry to this list with its scope and translation keys (`ADMIN_MENU.FORMS.*` in the root
 *    translation files, `FORMS.INSTANCES_LIST.*` in the `forms` translation scope).
 *    - Existing scope: reference it, no further changes needed.
 *    - New scope: add it first to `UserRoleScope` (`user-api/enums/user-role-scope.enum.ts`), then reference it here.
 * 3. Regenerate the form API swagger (`npm run zod-to-openapi` in `backend/services/form-api`).
 *
 * Menu sub-items, list heading, route checks, backend access checks and e-mail links derive from this list.
 */
export const formCategoriesList = [
  {
    category: FormCategory.MarketAggregatedData,
    scope: UserRoleScope.FormsMarketAggregatedData,
    menuLabelKey: 'ADMIN_MENU.FORMS.MARKET_AGGREGATED_DATA',
    listLabelKey: 'FORMS.INSTANCES_LIST.MARKET_AGGREGATED_DATA',
  },
  {
    category: FormCategory.ManualMarketData,
    scope: UserRoleScope.FormsManualMarketData,
    menuLabelKey: 'ADMIN_MENU.FORMS.MANUAL_MARKET_DATA',
    listLabelKey: 'FORMS.INSTANCES_LIST.MANUAL_MARKET_DATA',
  },
  {
    category: FormCategory.VansManualMarketData,
    scope: UserRoleScope.FormsVansManualMarketData,
    menuLabelKey: 'ADMIN_MENU.FORMS.VANS_MANUAL_MARKET_DATA',
    listLabelKey: 'FORMS.INSTANCES_LIST.VANS_MANUAL_MARKET_DATA',
  },
] as const satisfies readonly {
  readonly category: FormCategory;
  readonly scope: UserRoleScope;
  readonly menuLabelKey: string;
  readonly listLabelKey: string;
}[];
